function guaranteeCardsReducer(state = { cardsStatus: '', activeUnusedCards: [], gCardSearchList: null, gCardsFilters: null }, action) {
    switch (action.type) {
        case "GET_CARD_STATUS":
            return {
                ...state,
                cardsStatus: action.data
            };
        case "GET_ACTIVE_UNUSED_CARDS":
            return {
                ...state,
                activeUnusedCards: action.data
            }
        case "GCARDS_SEARCH_LIST":
            return {
                ...state,
                gCardSearchList: action.data
            }
        case "GCARDS_FILTERS":
            return ({
                ...state,
                gCardsFilters: action.data
            })
        case "FIXABLE_SERIALS":
            return ({
                ...state,
                fixableSerials: action.data
            })
        default:
            return state;
    }

}
export default guaranteeCardsReducer;